export function ApiProperty() {
    return () => { };
}
export function ApiPropertyOptional() {
    return () => { };
}
export function ApiResponseProperty() {
    return () => { };
}
export function ApiExtraModels() {
    return () => { };
}
export function refs() {
    return () => { };
}
export function getSchemaPath() {
    return () => { };
}
//# sourceMappingURL=index.js.map